import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { BarChart } from "@mui/x-charts/BarChart";
import * as React from "react";
import axiosInstance from "../utils/axiosInstance";
import { Stack } from "@mui/material";

export default function ContentViewsBarChart() {
  const [contentViews, setContentViews] = React.useState();

  const fetchContentViews = React.useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/stats/downloads-views`,
      );

      if (response.status === 200) {
        setContentViews(response.data);
      }
    } catch (error) {
      console.error("Error fetching most downloaded PDFs", error);
    }
  }, []);

  React.useEffect(() => {
    fetchContentViews();
  }, [fetchContentViews]);

  const theme = useTheme();
  const colorPalette = [
    (theme.vars || theme).palette.primary.dark,
    (theme.vars || theme).palette.primary.main,
    (theme.vars || theme).palette.primary.light,
  ];

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          Content views and downloads
        </Typography>
        <Stack sx={{ justifyContent: "space-between" }}>
          <Stack
            direction="row"
            sx={{
              alignContent: { xs: "center", sm: "flex-start" },
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="h4" component="p">
              {contentViews &&
                contentViews.views.reduce(
                  (accumulator, currentValue) => accumulator + currentValue,
                  0,
                )}{" "}
              Views,
            </Typography>
            <Typography variant="h4" component="p">
              {contentViews &&
                contentViews.downloads.reduce(
                  (accumulator, currentValue) => accumulator + currentValue,
                  0,
                )}{" "}
              Downloads
            </Typography>
          </Stack>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Content views and downloads for the last 30 days
          </Typography>
        </Stack>
        {contentViews && (
          <BarChart
            borderRadius={8}
            colors={colorPalette}
            xAxis={[
              {
                scaleType: "band",
                categoryGapRatio: 0.5,
                data: contentViews.days,
              },
            ]}
            series={[
              {
                id: "views",
                label: "Views",
                data: contentViews.downloads,
                stack: "A",
              },
              {
                id: "downloads",
                label: "Downloads",
                data: contentViews.views,
                stack: "A",
              },
            ]}
            height={250}
            margin={{ left: 50, right: 0, top: 20, bottom: 20 }}
            grid={{ horizontal: true }}
            slotProps={{
              legend: {
                hidden: true,
              },
            }}
          />
        )}
      </CardContent>
    </Card>
  );
}
